// src/views/ResetPassword.tsx
import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import NewPassForm from '../components/ResetPassword/NewPassForm';
import loginImage from '../static/ColourBrandPrimary2x.png';
import '../style/Login.css';

const ResetPassword: React.FC = () => {
    const params = useParams<{ token?: string, userId?: string }>();

    React.useEffect(() => {
        document.body.classList.add('login-page');
        return () => {
            document.body.classList.remove('login-page');
        };
    }, []);

    if (!params.token || !params.userId) {
        // Redirect to another page or show an error message
        return <Navigate to="/login" />;
        // or return <div>Invalid reset password link</div>;
    }


    return (
        <div className="login-view">
            <div className="login-container">
                <div className="image-container">
                    <img src={loginImage} alt="Login" className="login-image" />
                </div>
                <div className="form-container">
                    <NewPassForm token={params.token} userId={params.userId} />
                </div>
            </div>
        </div>
    );
};

export default ResetPassword;
